import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClipboardAt24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconClipboardAt24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 4h6a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25H9a.25.25 0 0 1-.25-.25v-1A.25.25 0 0 1 9 4M7.268 4A1.75 1.75 0 0 1 9 2.5h6A1.75 1.75 0 0 1 16.732 4H17a3 3 0 0 1 3 3v2.584a6 6 0 0 0-1.5-1.378V7A1.5 1.5 0 0 0 17 5.5h-.268A1.75 1.75 0 0 1 15 7H9a1.75 1.75 0 0 1-1.732-1.5H7A1.5 1.5 0 0 0 5.5 7v11A1.5 1.5 0 0 0 7 19.5h.206A6 6 0 0 0 8.584 21H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm6.482 12.75c.62 0 1.5-.67 1.5-2s-.88-2-1.5-2-1.5.67-1.5 2 .88 2 1.5 2m1.77-4.826a2.7 2.7 0 0 0-1.77-.674c-1.657 0-3 1.567-3 3.5s1.343 3.5 3 3.5c.66 0 1.271-.25 1.767-.671.277.405.743.671 1.27.671h.888A2.325 2.325 0 0 0 20 15.925v-1.95A5.475 5.475 0 0 0 14.525 8.5h-1.55A5.475 5.475 0 0 0 7.5 13.975v1.55A5.475 5.475 0 0 0 12.975 21h6.275a.75.75 0 0 0 0-1.5h-6.275A3.975 3.975 0 0 1 9 15.525v-1.55A3.975 3.975 0 0 1 12.975 10h1.55a3.975 3.975 0 0 1 3.975 3.975v1.95c0 .456-.37.825-.825.825h-.887a.04.04 0 0 1-.038-.038V12.5a.75.75 0 0 0-1.23-.576"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClipboardAt24);
